import { Box } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { useCampfireTheme } from '../../theme/useCampfireTheme';

type StyleProps = {
  width?: string;
  height?: string;
};

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      width: (props: StyleProps) => (props.width ? props.width : '100%'),
      height: (props: StyleProps) => (props.height ? props.height : '100%'),
      borderRadius: '8px',
      boxSizing: 'border-box',
      marginTop: '15px',
      '&:hover': {
        cursor: 'pointer',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
      },
    },
  })
);

interface Props {
  color?: string;
  bgColor?: string;
  width?: string;
  height?: string;
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

export const VolabyCard = (props: Props) => {
  const { color, bgColor, width, height, selected, onClick, children } = props;
  const { theme } = useCampfireTheme();
  const classes = useStyles({ width, height });

  return (
    <Box
      className={classes.card}
      border={selected ? `2px solid ${color}` : `1px solid ${theme.color.grey.border}`}
      style={{ padding: selected ? 0 : 1 }}
      bgcolor={bgColor ?? theme.color.grey.neutralBrand100}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};
